function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 175.8212 80.8848)",
  className: "st0"
}, "Set A");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st3",
  d: "M70.7,79.6H13.5l-0.1-38.9h4.4l52.9,35.5V79.6z M18.8,74.3h39.9L18.8,47.8V74.3z"
}), React.createElement("path", {
  className: "st3",
  d: "M85.6,76.1l52.9-35.4h4.4l-0.1,38.9H85.6C85.6,79.6,85.6,76.1,85.6,76.1z M137.5,47.8L97.6,74.4h39.9V47.8z"
}), React.createElement("rect", {
  x: 59.5,
  y: 17,
  className: "st3",
  width: 37.4,
  height: 32
}));

var SvgSetAIcon = function SvgSetAIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 391.1 93",
    style: {
      enableBackground: "new 0 0 391.1 93"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSetAIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/set-a-icon.488fa111.svg";
export { ForwardRef as ReactComponent };